import { PhysicalInventoryStateEnums } from 'src/app/enum/physical-inventory-state-enums';

export class PhysicalInventoryModel {
  physicalInventoryId: number = 0;
  branchId: number = 0;
  inventoryId: number = 0;
  storeId: number = 0;
  consecutive: number = 0;
  datePhysicalInventory: Date = new Date();
  dateAdjustment: Date = new Date();
  physicalInventoryStateId: number = PhysicalInventoryStateEnums.open;
  swExcessAdjustment: boolean = false;
  swMissingAdjustment: boolean = false;
  observation: string | null = null;
  createDate: Date = new Date();
  userNameCreate: string = '';
  updateDate: string | null = null;
  userNameUpdate: string | null = null;
}
